import {
  Avatar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { THEME } from "../../theme";
import { styles } from "../TracksPageComponents/styles";
import { useContext, useEffect, useState } from "react";
import {
  UserDetailsContext,
  UserDetailsContextInterface,
} from "../../contexts";
import GroupIcon from "@mui/icons-material/Group";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { useAuth0 } from "@auth0/auth0-react";
import { getThumbnailUrl } from "../../utils/thumbnailUtil";
import { DrawerProfileDetailsProps } from "./types";
import { Role } from "../../proto/api_pb";

export const DrawerProfileDetails: React.FC<DrawerProfileDetailsProps> = ({
  currentUser,
}) => {
  const [avatarImage, setAvatarImage] = useState("");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { isEnterpriseAccount, enterprises, userName } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);
  const navigate = useNavigate();
  const { loginWithRedirect, logout } = useAuth0();
  const { enterprise } = useContext(UserDetailsContext);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const helper = async () => {
      if (currentUser && currentUser.getProfilePicture()) {
        const thumbnailUrl = await getThumbnailUrl(
          currentUser.getProfilePicture()
        );
        setAvatarImage(thumbnailUrl);
      } else {
        setAvatarImage("/static/images/avatar/2.jpg");
      }
    };
    helper();
  }, [currentUser]);

  return (
    <>
      {currentUser ? (
        <Box sx={{ margin: "10px 0" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box
              onClick={() => {
                navigate("/user-profile/" + userName);
              }}
              sx={styles.avatarAndNameContainer}
            >
              <Avatar
                alt={currentUser?.getUsername().toUpperCase() ?? ""}
                src={avatarImage}
              />
              <Box>
                <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>{`${
                  currentUser !== undefined ? currentUser?.getFirstName() : ""
                } ${
                  currentUser !== undefined ? currentUser?.getLastName() : ""
                }`}</Typography>
                <Typography sx={{ fontSize: "14px" }}>
                  {currentUser !== undefined ? currentUser?.getEmail() : ""}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <IconButton
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                <MoreVertIcon fontSize="small" />
              </IconButton>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: { border: "1px solid #26292B" },
                }}
                sx={styles.moreVerticalIconMenu}
              >
                {isEnterpriseAccount && (
                  <MenuItem
                    onClick={() => {
                      navigate("/team-management");
                      handleClose();
                    }}
                  >
                    <GroupIcon sx={{ margin: "2px", marginRight: "8px" }} />
                    Team Management
                  </MenuItem>
                )}
                {!isEnterpriseAccount ||
                Number(enterprise?.role) === Role.ROLE_ADMIN ? (
                  <MenuItem
                    onClick={() => {
                      navigate("/billing");
                      handleClose();
                    }}
                  >
                    <img
                      style={{
                        margin: "2px",
                        marginRight: "8px",
                        filter:
                          THEME === "light" ? "invert(100%)" : "invert(0%)",
                      }}
                      src="/assets/icons/TracksPageIcons/receipt.svg"
                      alt=""
                    />
                    Billing
                  </MenuItem>
                ) : null}
                {enterprises.length > 1 && (
                  <MenuItem
                    onClick={() => {
                      sessionStorage.clear();
                      window.location.href = "/select-enterprise";
                      handleClose();
                    }}
                  >
                    <PublishedWithChangesIcon
                      sx={{ margin: "2px", marginRight: "8px" }}
                    />
                    Switch Account
                  </MenuItem>
                )}
                <MenuItem
                  onClick={() => {
                    logout({
                      logoutParams: {
                        returnTo: window.location.origin + "/logout",
                      },
                    });
                    sessionStorage.clear();
                    handleClose();
                  }}
                >
                  {" "}
                  <img
                    style={{
                      margin: "2px",
                      marginRight: "8px",
                      filter: THEME === "light" ? "invert(100%)" : "invert(0%)",
                    }}
                    src="/assets/icons/TracksPageIcons/log-out-02.svg"
                    alt=""
                  />{" "}
                  Logout
                </MenuItem>
              </Menu>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box>
          <Button
            onClick={() => {
              localStorage.clear();
              loginWithRedirect({
                appState: { targetUrl: "/initial-setting" },
                authorizationParams: { screen_hint: "signup" },
              });
            }}
            sx={styles.button}
          >
            Log in / Sign up
          </Button>
        </Box>
      )}
      <Box sx={{ border: "1px solid #26292B", margin: "10px 0" }}></Box>
    </>
  );
};
